export function rando(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export function toWKT(bounds) {

    if(! bounds) {
        return  '';
    }

    let WKT = "POLYGON((";

    WKT +=  bounds.nw.lng + ' ' + bounds.nw.lat + ',';
    WKT +=  bounds.ne.lng + ' ' + bounds.ne.lat + ',';
    WKT +=  bounds.se.lng + ' ' + bounds.se.lat + ',';
    WKT +=  bounds.sw.lng + ' ' + bounds.sw.lat + ',';
    WKT +=  bounds.nw.lng + ' ' + bounds.nw.lat + '';

    return WKT += '))';
}

export function getIcon($type) {
    switch ($type) {
        case "listing":
            return "fa-bed bg-info";
            break;

        case "event":
            return "fa-calendar-alt bg-accent";
            break;

        case "place":
            return "fa-thumbtack bg-danger";
            break;

        case "airport":
            return "fa-plane bg-success";
            break;
    }

    return  "fa-map-marker-alt bg-secondary";
}
